export default __webpack_public_path__ + "static/media/onboarding.1198b3f7.jpeg";